<template>
    <div class="question">
        <div class="question-box">
            <img
                    @click="getFish"
                    class="fish f1"
                    :src="'//cdn.original-fun.com/gugong/锦鲤1.png'"
            />
            <img
                    @click="getFish"
                    class="fish f2"
                    :src="'//cdn.original-fun.com/gugong/锦鲤2.png'"
            />
            <img
                    @click="getFish"
                    class="fish f3"
                    :src="'//cdn.original-fun.com/gugong/锦鲤3.png'"
            />

            <img :src="'//cdn.original-fun.com/gugong/锦鲤底图.png'" class="bg"/>
            <img
                    :src="'//cdn.original-fun.com/gugong/锦鲤上层遮罩.png'"
                    class="bg mask"
            />
        </div>
        <div class="text">{{ titleText }}</div>
        <HeadTip :data="data"></HeadTip>
    </div>
</template>

<script>
    //script
    import Tools from '../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../scripts/Global';

    //组件
    import HeadTip from './headTip';

    export default {
        props: ['data'],
        data() {
            return {
                titleText: this.data.qText,
                selectedIndex: undefined,
                selectedData: undefined,
                right: undefined,
            };
        },
        components: {HeadTip},
        created() {
        },
        computed: {},
        methods: {
            getFish() {
                this.$emit('jump', true);
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .question {
        background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
        background-position: 0 90%;
        width: 7.5rem;
        height: 9rem;
        margin: 0 auto;
        background-repeat: no-repeat;
        position: relative;
        bottom: 0;
        background-size: contain;
        top: 50%;
        margin-top: -5rem;
        position: absolute;
        font-size: 12px;
        .question-box {
            position: relative;
            width: 5rem;
            height: 3rem;
            margin: 2.5rem auto 0.3rem auto;
            .bg {
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }
            .mask {
                z-index: 3;
                pointer-events: none;
            }
            .fish {
                width: 1.2rem;
                position: absolute;
                z-index: 2;
                &.f1 {
                    animation: fishRotate 6s infinite ease-out;
                    top: 54%;
                    left: 19%;
                }
                &.f2 {
                    animation: fishRotate 6s 3s infinite ease-out;
                    top: 10%;
                    left: 31%;
                }
                &.f3 {
                    animation: fishRotate 5s 4s infinite ease-out;
                    top: 51%;
                    left: 62%;
                }
            }
        }
        .text {
            width: 5rem;
            margin: 0.2rem auto 1.1rem auto;
            text-align: center;
        }
        .answer-box {
            width: 6rem;
            background: #9c9c9c;
            margin: 0 auto;
            padding: 0.3rem 0 0.3rem 0px;
            position: relative;
            overflow: hidden;
            .a {
                background: #c72d2d;
                width: 1.6rem;
                height: 1.5rem;
                margin: 0 0.2rem;
                position: relative;
                float: left;
            }
            .duigou {
                display: none;
                background-image: url(//cdn.original-fun.com/gugong/对勾.png);
                background-position: center;
                background-size: contain;
                width: 1rem;
                height: 1rem;
                background-repeat: no-repeat;
                position: absolute;
                bottom: 0;
                right: 0;
                &.show {
                    display: block;
                }
            }
            .side-man {
                display: none;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 2rem;
                background: #4f8a0f;
                height: 4rem;
                .img {
                    position: absolute;
                    bottom: 0px;
                    left: 0;
                }
            }
        }
        .button {
            background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
            position: absolute;
            width: 3rem;
            height: 1rem;
        }
    }
    @keyframes fishRotate {
        0% {transform: rotate(0)}
        5%, 15%, 25% {transform: rotate(3deg) translateX(-1px) scale(0.97)}
        10%, 20%, 30% {transform: rotate(0deg)}
    }
</style>
